import Stack from '@mui/material/Stack';
import { CallToAction } from './components/CallToAction.tsx';
import { sampleCTAs } from './utils/sampleCTAs.ts';

export const CTASection = () => {
  return (
    <Stack direction="column" sx={{ gap: 0.75 }}>
      {sampleCTAs.map(cta => (
        <CallToAction key={cta.text} {...cta} />
      ))}
    </Stack>
  );
};
